import { Component } from '@angular/core';

@Component({
  selector: 'app-money-rules',
  templateUrl: './money-rules.component.html',
  styleUrl: './money-rules.component.scss'
})
export class MoneyRulesComponent {
  items = [
    {
      title: 'قانون المناقصات والمزايدات',
      content: 'يعمل بأحكام القانون المرافق في شأن تنظيم المناقصات والمزايدات ، وتسري أحكامه على وحدات الجهاز الإداري للدولة – من وزارات ، ومصالح ، وأجهزة لها موازنات خاصة – وعلى وحدات الإدارة المحلية ، وعلى الهيئات العامة ، خدمية كانت أو اقتصادية ويلغى القانون رقم 147 لسنة 1962 بشأن تنفيذ أعمال خطة التنمية الاقتصادية ، وقانون تنظيم المناقصات والمزايدات الصادر بالقانون رقم 9 لسنة 1983 ، كما يلغى كل حكم آخر يخالف أحكام القانون المرافق .',
      mainLinksLabel: 'لقراءة المزيد عن القانون,',
      mainLinks: [],
      expanded: false,
    },
    {
      title: 'قانون الرهن العقاري',
      content: 'يقدم قانون الرهن العقاري رقم 148 لسنة 2001 إطاراً تنظيمياً لإصدار صكوك الرهن العقاري عن طريق المؤسسات البنكية وغير البنكية، كما ينظم توريق الرهون العقارية بهدف زيادة النشاط التجاري في سوق الأوراق المالية، حيث يمكن هذا القانون المقترضين من دفع 20% دفعة أولى والباقي يسدد على أقساط لمدة تتراوح بين عشرين وثلاثين عاماً، وتعتبر العائلات متوسطة الدخل أكبر المستفيدين من القانون الجديد.',
      mainLinksLabel: 'لقراءة المزيد عن القانون,',
      mainLinks: [
        { text: 'اضغط هنا', url: 'assets/قانون الرهن العقاري.pdf' }
      ],
      expanded: false,
    },
    {
      title: 'قانون مكافحة غسيل الأموال',
      content: 'ينظم قانون مكافحة غسيل الأموال رقم 80 لسنة 2002 القواعد والإجراءات اللازمة لمنع غسيل الأموال في مصر، ويعطي السلطات المختصة الصلاحيات اللازمة للرقابة والتحقيق ومصادرة الأموال غير المشروعة، وذلك لضمان سلامة النظام المالي والاقتصادي.',
      mainLinksLabel: 'لقراءة المزيد عن القانون,',
      mainLinks: [
        { text: 'اضغط هنا', url: 'assets/قانون مكافحة غسيل الاموال.pdf' }
      ],
      expanded: false,
    },
    {
      title: 'قانون التأمين',
      content: 'يقوم القانون رقم 10 لسنة 1981 وتعديلاته (القانون رقم 156 لسنة 1998 والقانون رقم 91 لسنة 1995) بتنظيم والإشراف على سوق التأمين، حيث تم إلغاء مصاريف التأمين تقريباً منذ عام 1996 مما قلل أقساط التأمين بشكل ملحوظ، ويحق للقطاع الخاص بموجب لهذا القانون، امتلاك 100% من أسهم أي شركة تأمين مصرية مملوكة بالكامل للحكومة. وتطبق هذه الفقرة على مستثمري القطاع الخاص المصريين والأجانب. وتعتبر الهيئة العامة للرقابة المالية مكلفة بالإشراف والرقابة على الأنشطة التأمينية، وتعد حماية حقوق حملة وثائق التأمين والمستفيدين والأطراف الثالثة والمحافظة على القانون والنظام في السوق أهم مهام الهيئة.',
      mainLinksLabel: 'لقراءة المزيد عن القانون,',
      mainLinks: [
        { text: 'اضغط هنا لقرار رقم 22 لسنة 2012', url: 'assets/edit 12.pdf' },
        { text: 'اضغط هنا لقانون رقم 118 لسنة 2008', url: 'assets/edit 2008.pdf' },
        { text: 'اضغط هنا لقانون رقم 10 لسنة 1981', url: 'assets/law 10 (1).pdf' }
      ],
      expanded: false,
    },
    {
      title: 'قانون الموازنة العامة',
      content: 'يقوم القانون رقم 97 لسنة 2005 بتعديل مواد القانون رقم 53 لسنة 1973 وذلك لتحسين طريقة عرض الموازنة، وخاصة إعادة تصنيف 77 بند بطريقة ما لزيادة الشفافية والتفريق بين الأنواع المختلفة للإيرادات وفصلهم عن المصادر المتاحة لتمويل عجز الموازنة، ويقوم القانون بتحسين طريقة عرض تفاصيل وإجمالي النفقات العامة.',
      mainLinksLabel: 'لقراءة المزيد عن القانون,',
      mainLinks: [
        { text: 'اضغط هنا', url: 'assets/قانون الموازنة العامة.pdf' }
      ],
      expanded: false,
    },
    {
      title: 'قانون رقم 192 لسنة 2009',
      content: 'يختص القانون رقم 192 لسنة 2009 بتنظيم عمل الهيئة العامة للرقابة المالية باعتبارها شخص اعتباري عام، وتختص الهيئة العامة للرقابة المالية بالرقابة والاشراف على الأسواق والأدوات المالية غير المصرفية بما في ذلك أسواق رأس المال، وبورصات العقود الآجلة، وأنشطة التأمين، والتمويل العقاري، والتأجير التمويلي، والتوريق.',
      mainLinksLabel: 'لقراءة المزيد عن القانون,',
      mainLinks: [
        { text: 'اضغط هنا', url: 'assets/قانون 192 لسنة 2009.pdf' }
      ],
      expanded: false,
    },
    {
      title: 'قانون سوق المال',
      content: 'ينظم قانون سوق المال رقم 95 لسنة 1992 وتعديله بالقرار رقم 39 لسنة 1998 أسواق المال في مصر ويعطي هيئة سوق المال السلطة القانونية والوضع الشرعي اللازم لضمان التنفيذ الفعال لقوانين ولوائح سوق الأوراق المالية.',
      mainLinksLabel: 'لقراءة المزيد عن القانون,',
      mainLinks: [
        { text: 'اضغط هنا لقرار وزير الاقتصاد والتجارة رقم 135 لسنة 1993', url: 'assets/sooq mal 95.pdf' },
        { text: 'اضغط هنا لقرار رقم 39 لسنة 1998', url: 'assets/sooq mal edit.pdf' }
      ],
      expanded: false,
    },
    {
      title: 'قوانين المصارف',
      content: 'يقوم قانون المصارف رقم 88 لسنة 2003 (البنك المركزي والقطاع المصرفي والنظام المالي) بتنظيم عمل البنك المركزي المصري والقطاع المصرفي والمعاملات في النقد الأجنبي وسرية الحسابات، والملكية الخاصة لبنوك القطاع العام، حيث يشدد القانون من الإجراءات البنكية التدبيرية ويرفع الحد الأدنى من متطلبات رأس المال للبنوك، ومكاتب الصرافة، ويؤكد على سلطة الحكومة في خصخصة بنوك القطاع العام، وتم إصدار اللائحة التنفيذية لقانون المصارف في مارس 2004.',
      mainLinksLabel: 'لقراءة المزيد عن القانون,',
      mainLinks: [
        { text: 'اضغط هنا لقانون 66 لسنة 2016', url: 'assets/edit 66.pdf' },
        { text: 'اضغط هنا لقرار رئيس الجمهورية رقم 101 لسنة 2004', url: 'assets/edit 2003.pdf' }
      ],
      expanded: false,
    }
  ];

  toggle(item: any) {
    item.expanded = !item.expanded;
  }
}
